import { render, staticRenderFns } from "./AddOrganisationUserModal.vue?vue&type=template&id=0492946c&scoped=true"
import script from "./AddOrganisationUserModal.vue?vue&type=script&lang=ts"
export * from "./AddOrganisationUserModal.vue?vue&type=script&lang=ts"
import style0 from "./AddOrganisationUserModal.vue?vue&type=style&index=0&id=0492946c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0492946c",
  null
  
)

export default component.exports